import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Copy } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useAlertaFaixa } from './alertas/AlertasContexto';

// Faixa de NOTA EM DOBRO ([DA-490]) — a venda saiu com mais de uma nota autorizada viva.
//
// Vermelho de topo (#ef4444, o mesmo grau de "Contas a pagar vencida") por dois motivos:
// e dinheiro declarado DUAS vezes ao fisco, e o normal absoluto desta faixa e nao existir.
// Nao ha risco de virar papel de parede — o que a [DA-360] cobra — justamente porque ela
// so acende no caso raro: 3 ocorrencias em 15 meses de operacao, e a trava da [DA-489] ja
// fechou a causa conhecida.
//
// Conta SO o que ainda nao tem "ciente" (o endpoint ja devolve assim). E o que permite a
// faixa APAGAR depois que o Ruan viu cada caso — sem isso ela ficaria acesa pra sempre
// pelos 3 historicos, que ele decidiu nao mexer (mes fiscal fechado), e a 4a nota nao
// mudaria nada na tela.
//
// Sem "X" de dispensar: o botao "Ciente" da propria aba ja e o gesto de baixar o alarme, e
// ele fica gravado com data e autor. Um X local no navegador seria a mesma coisa sem
// memoria — e um caso destes nao pode sumir porque alguem limpou a tela sem olhar.
interface Resumo { total: number }

const POLLING_MS = 5 * 60 * 1000;

export function AlertaNotasDuplicadasBanner() {
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const [resumo, setResumo] = useState<Resumo | null>(null);

  // Mesmo publico da aba: quem pode dar o "ciente" e decidir o que fazer com a nota.
  const podeVer = usuario && ['admin', 'gerente'].includes(usuario.perfil);

  useEffect(() => {
    if (!podeVer) return;
    let cancelado = false;
    async function tick() {
      try {
        const r = await api.get<Resumo>('/api/notas-fiscais/duplicadas-resumo');
        if (!cancelado) setResumo(r);
      } catch { /* silencioso: a faixa some, o resto da tela nao cai por causa dela */ }
    }
    void tick();
    const id = setInterval(tick, POLLING_MS);
    return () => { cancelado = true; clearInterval(id); };
  }, [podeVer]);

  const ativo = !!(podeVer && resumo && resumo.total > 0);
  const recolhido = useAlertaFaixa(
    'notas-duplicadas',
    ativo ? { rotulo: 'Nota em dobro', bg: '#ef4444', borda: '#b91c1c', qtd: resumo!.total } : null,
  );

  if (!ativo || recolhido || !resumo) return null;

  const n = resumo.total;
  return (
    <div
      style={{
        background: '#ef4444',
        borderLeft: '4px solid #b91c1c',
        color: '#000',
        padding: '8px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontSize: 13,
        cursor: 'pointer',
      }}
      onClick={() => navigate('/notas-fiscais?aba=duplicadas')}
    >
      <Copy size={16} />
      <span style={{ fontWeight: 600 }}>Nota em dobro:</span>
      <span>
        {n === 1
          ? '1 venda saiu com duas notas autorizadas'
          : `${n} vendas sairam com mais de uma nota autorizada`}
        {' '}— o cliente recebeu duas e o valor foi declarado duas vezes
      </span>
      <span style={{ marginLeft: 'auto', textDecoration: 'underline' }}>Conferir</span>
    </div>
  );
}
